import { updateObject } from '../../utils/utils';

import { REINIT_ALL_STATE } from '../sitewideReduxConstants';

import {
  GET_BOARD_MEMBERS_START,
  GET_BOARD_MEMBERS_SUCCESS,
  GET_BOARD_MEMBERS_FAILED,

  GET_BOARD_MEMBER_START,
  GET_BOARD_MEMBER_SUCCESS,
  GET_BOARD_MEMBER_FAILED,

  ADD_BOARD_MEMBER_START,
  ADD_BOARD_MEMBER_SUCCESS,
  ADD_BOARD_MEMBER_FAILED,

  UPDATE_BOARD_MEMBER_START,
  UPDATE_BOARD_MEMBER_SUCCESS,
  UPDATE_BOARD_MEMBER_FAILED,

  DELETE_BOARD_MEMBER_START,
  DELETE_BOARD_MEMBER_SUCCESS,
  DELETE_BOARD_MEMBER_FAILED,

  GET_COMMITTEES_START,
  GET_COMMITTEES_SUCCESS,
  GET_COMMITTEES_FAILED,

  ADD_COMMITTEE_MEMBER_START,
  ADD_COMMITTEE_MEMBER_SUCCESS,
  ADD_COMMITTEE_MEMBER_FAILED,

  REMOVE_COMMITTEE_MEMBER_START,
  REMOVE_COMMITTEE_MEMBER_SUCCESS,
  REMOVE_COMMITTEE_MEMBER_FAILED,

  GET_BOARD_N_COMMITTEES_START,
  GET_BOARD_N_COMMITTEES_SUCCESS,
  GET_BOARD_N_COMMITTEES_FAILED,

  ADD_COMMITTEE_START,
  ADD_COMMITTEE_SUCCESS,
  ADD_COMMITTEE_FAILED,

  UPDATE_COMMITTEE_START,
  UPDATE_COMMITTEE_SUCCESS,
  UPDATE_COMMITTEE_FAILED,

  DELETE_COMMITTEE_START,
  DELETE_COMMITTEE_SUCCESS,
  DELETE_COMMITTEE_FAILED

} from '../actions/boardMemberActions';

const INITIAL_STATE = {
  updating: false,
  board_members: [],
  current_member: null,
  committee_member_updated: false,
  committees: [],
  error: null
}

// const updateCommitteeMembers = (state, )
const updateBoardMembers = (state, boardMember) => {
  const ix = state.board_members.findIndex((bm) => {
    if (bm.id === boardMember.id) {
      return true;
    } else {
      return false;
    }
  })
  const updBoardMembers = [...state.board_members];
  updBoardMembers[ix] = {...boardMember};
  return updBoardMembers;
}

const updateCommittee = (state, committee) => {
  const ix = state.committees.findIndex((c) => {
    if (c.id === committee.id) {
      return true;
    } else {
      return false;
    }
  })
  const updCommittees = [...state.committees];
  updCommittees[ix] = {...committee};
  return updCommittees;
}

const reducer = (state = INITIAL_STATE, action) => {
  // console.log(`[boardMemberReducers]: ${action.type}`, action.payload);
  switch (action.type) {
    case REINIT_ALL_STATE:
      return INITIAL_STATE;

    case GET_BOARD_MEMBERS_START:
      return updateObject(state, {updating: true});

    case GET_BOARD_MEMBERS_FAILED:
    case GET_BOARD_MEMBER_FAILED:
    case ADD_BOARD_MEMBER_FAILED:
    case UPDATE_BOARD_MEMBER_FAILED:
    case GET_COMMITTEES_FAILED:
    case ADD_COMMITTEE_MEMBER_FAILED:
    case REMOVE_COMMITTEE_MEMBER_FAILED:
    case DELETE_BOARD_MEMBER_FAILED:
    case ADD_COMMITTEE_FAILED:
    case UPDATE_COMMITTEE_FAILED:
      return updateObject(state, {updating: false, committee_member_updated: false});

    case GET_BOARD_MEMBERS_SUCCESS:
      return updateObject(state, {updating: false, board_members: action.payload.board_members, committee_member_updated: false});

    case GET_BOARD_MEMBER_START:
      return updateObject(state, {updating: true});
    
    case UPDATE_BOARD_MEMBER_START:
      // TODO: Do I want to clear current_member herE?
      return updateObject(state, {updating: true, current_member: null});

    case DELETE_BOARD_MEMBER_START:
      return updateObject(state, {updating: true, current_member: null});

    case DELETE_BOARD_MEMBER_SUCCESS:
      return updateObject(state, {updating: false, committee_member_updated: true});

    case UPDATE_BOARD_MEMBER_SUCCESS:
      return updateObject(state, {updating: false, current_member: {...action.payload.board_member}, board_members: updateBoardMembers(state, action.payload.board_member)});

    case GET_BOARD_MEMBER_SUCCESS:
      return updateObject(state, {updating: false, current_member: {...action.payload.board_member}})
        
    case ADD_BOARD_MEMBER_START:
      return updateObject(state, {updating: true});
    
    case ADD_BOARD_MEMBER_SUCCESS:
      return updateObject(state, {updating: false, board_members: [...state.board_members, {...action.payload.board_member}]});

    case GET_COMMITTEES_START:
      return updateObject(state, {updating: true, committees: []});

    case GET_COMMITTEES_SUCCESS:
      return updateObject(state, {updating: false, committees: action.payload.committees, committee_member_updated: false});

    case ADD_COMMITTEE_MEMBER_START:
    case REMOVE_COMMITTEE_MEMBER_START:
      return updateObject(state, {updating: true})

    case ADD_COMMITTEE_MEMBER_SUCCESS:
      //TODO: Add the committee member to the board member and to the corresponding committee
      //  boardMember has committees: {id: committee id, name: committee name, is_chair: [true, false]}
      //  committees has members, each member has: {id: cm_id, name: Bill Snapper, user_id: 1}
      return updateObject(state, {updating: false, committee_member_updated: true})      

    case REMOVE_COMMITTEE_MEMBER_SUCCESS:
      return updateObject(state, {updating: false, committee_member_updated: true})
    
    case GET_BOARD_N_COMMITTEES_START:
      return updateObject(state, {updating: true})

    case GET_BOARD_N_COMMITTEES_SUCCESS:
      return updateObject(state, {updating: false, board_members: action.payload.board_members, committees: action.payload.committees, 
                                  committee_member_updated: false});

    case GET_BOARD_N_COMMITTEES_FAILED:
      return updateObject(state, {updating: false, committee_member_updated: false});

    case ADD_COMMITTEE_START:
      return updateObject(state, {updating: true});

    case ADD_COMMITTEE_SUCCESS:
      return updateObject(state, {updating: false, committees: [...state.committees, {...action.payload.committee}]});

    case UPDATE_COMMITTEE_START:
      return updateObject(state, {updating: true});

    case UPDATE_COMMITTEE_SUCCESS:
      return updateObject(state, {updating: false, committees: updateCommittee(state, action.payload.committee)});

    case DELETE_COMMITTEE_START:
      return updateObject(state, {updating: true});

    case DELETE_COMMITTEE_SUCCESS:
      return updateObject(state, {updating: false, committee_member_updated: true});

    default:
      return state;
  }
}

export default reducer;
